import { Controller } from '@hotwired/stimulus'

// Mutual exclusion for Review of Systems checkbox groups.
// Any checkbox marked data-exclusive="true" (e.g. "Essentially normal",
// "Not Applicable") disables all others when checked, and is itself
// disabled when any non-exclusive checkbox is checked.
// The "Others" checkbox (data-others="true") enables an inline rem textarea
// (data-others-rem wrapper); grayed and read-only when unchecked.
// Mount one instance per system wrapper.
export default class extends Controller {
  connect() {
    this.#sync()
    this.#applyOthersRem(false)
  }

  toggle(event) {
    const cb = event.currentTarget
    const isExclusive = cb.dataset.exclusive === 'true'

    if (isExclusive && cb.checked) {
      this.#exclusiveCheckboxes.forEach(other => { if (other !== cb) other.checked = false })
      this.#regularCheckboxes.forEach(other => { other.checked = false })
    } else if (!isExclusive && cb.checked) {
      this.#exclusiveCheckboxes.forEach(other => { other.checked = false })
    }

    this.#sync()
    this.#applyOthersRem(true)
  }

  get #exclusiveCheckboxes() {
    return Array.from(this.element.querySelectorAll('input[type="checkbox"][data-exclusive="true"]'))
  }

  get #regularCheckboxes() {
    return Array.from(this.element.querySelectorAll('input[type="checkbox"]:not([data-exclusive="true"])'))
  }

  #sync() {
    const exclusives = this.#exclusiveCheckboxes
    const regulars = this.#regularCheckboxes
    const anyExclusiveChecked = exclusives.some(cb => cb.checked)
    const anyRegularChecked = regulars.some(cb => cb.checked)

    if (anyExclusiveChecked) {
      exclusives.forEach(cb => this.#setGrayed(cb, !cb.checked))
      regulars.forEach(cb => this.#setGrayed(cb, true))
    } else if (anyRegularChecked) {
      exclusives.forEach(cb => this.#setGrayed(cb, true))
      regulars.forEach(cb => this.#setGrayed(cb, false))
    } else {
      const all = [...exclusives, ...regulars]
      all.forEach(cb => this.#setGrayed(cb, false))
    }
  }

  #applyOthersRem(shouldClear) {
    const ta = this.element.querySelector('[data-others-rem] textarea')
    if (!ta) return
    const othersCb = this.element.querySelector('input[type="checkbox"][data-others="true"]')
    if (!othersCb) return
    const enabled = othersCb.checked
    if (!enabled && shouldClear) ta.value = ''
    ta.readOnly = !enabled
    ta.required = enabled
    ta.classList.toggle('opacity-50', !enabled)
    ta.classList.toggle('bg-gray-100', !enabled)
    ta.classList.toggle('cursor-not-allowed', !enabled)
  }

  #setGrayed(cb, grayed) {
    cb.disabled = grayed
    const wrapper = cb.closest('.flex')
    if (wrapper) {
      wrapper.classList.toggle('opacity-50', grayed)
      wrapper.classList.toggle('cursor-not-allowed', grayed)
    }
  }
}
